import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import './Home.css';

export default function Home() {
  return (
    <div className="home-container">
      {/* Simple Header */}
      <header className="simple-header">
        <nav className="simple-nav">
          <div className="nav-brand">
            <span className="logo-text">Volcan<span className="logo-highlight">AI</span></span>
          </div>
          <div className="nav-menu">
            <a href="#" className="nav-item">Learn more</a>
          </div>
        </nav>
      </header>

      {/* Main Content */}
      <main className="main-content">
        <motion.div 
          className="hero-container"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <motion.div 
            className="badge"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.2, duration: 0.6 }}
          >
            New | Introducing VolcanAI Web | Learn more
          </motion.div>
          
          <h1 className="main-title">
            AI for every<br />
            <span className="highlight">CatWeb Developer</span>
          </h1>
          
          <p className="subtitle">
            VolcanAI is a powerful tool that allows anyone to easily create CatWeb websites using AI. Try it now, it's free.
          </p>
          
          <div className="button-group">
            <Link to="/chat" className="btn-primary">
              Get Started
            </Link>
            <Link to="/developers" className="btn-secondary">
              Developers
            </Link>
          </div>
        </motion.div>
      </main>
    </div>
  );
}